import React from 'react';
import PropTypes from 'prop-types';
import { ORG_TYPES, USER_TYPES } from '../../common/constants';
import SignupFormWrapper from './SignupFormWrapper';

const BENEFIT_URL_FOLDER = 'https://replate-storage.s3.us-west-1.amazonaws.com/assets/icons/signup_page';
const benefitsDescriptions = {
  BUSINESS: [
    {
      img: {
        src: '01_people.svg',
        alt: 'Two hands clapping.',
      },
      text: 'Elevate your company culture',
    },
    {
      img: {
        src: '02_support.svg',
        alt: 'A hand holding a steaming bowl of food.',
      },
      text: 'Support your local community with food donation',
    },
    {
      img: {
        src: '03_schedule.svg',
        alt: 'A clock icon in front of day calendar.',
      },
      text: 'Schedule a surplus food pickup in seconds',
    },
  ],
  RECIPIENT: [
    {
      img: {
        src: '01_food.svg',
        alt: 'Two chefs, and one is holding a tray of food aloft.',
      },
      text: 'Professionally prepared food delivered straight to your organization',
    },
    {
      img: {
        src: '02_schedule.svg',
        alt: 'A day on a calendar with a check mark.',
      },
      text: 'Customize your donation schedule',
    },
    {
      img: {
        src: '03_hand.svg',
        alt: 'An upturned hand holding a growing seedling.',
      },
      text: 'Spend more time focusing on the core of your organization',
    },
  ],
};

/**
 * Page shown when user clicks Signup link from the site
 * or from email invite.
 * If shown via email invite, user param will not be null,
 * which means we are actually editing an existing user in the database.
 * Shows some descriptive text on left-hand side and form on right-hand side.
 */
function SignupPage({ orgType, user, userType }) {
  let benefits = benefitsDescriptions.BUSINESS;
  let logoName = 'logo-color';
  let signupTitle = 'Donor Sign Up';

  if (orgType === ORG_TYPES.RECIPIENT || orgType === ORG_TYPES.HOUSEHOLD) {
    benefits = benefitsDescriptions.RECIPIENT;
    logoName = 'logo-blue';
    signupTitle = 'Recipient Sign Up';
  }

  const logoURL = `https://replate-storage.s3.us-west-1.amazonaws.com/assets/logos/${logoName}.svg`;

  return (
    <div className="container grid-xl signup-container">
      <div className="row mt-5 pt-4">
        <div className="col-md-6 col-sm-4 col-12 title-container">
          <img
            src={logoURL}
            alt="Replate Logo"
            className="signup-img"
          />
          <h1 className="h2 mb-1">
            {signupTitle}
          </h1>
          <p className="desc-text desc-text--small mb-4">
            You're just one step away from joining the Replate Community!
          </p>
          <ul className="benefits">
            { benefits.map((benefit) => (
              <li className="benefits-item" key={benefit.img.src}>
                <div className="benefits-img">
                  <img src={`${BENEFIT_URL_FOLDER}/${benefit.img.src}`} alt={benefit.img.alt} />
                </div>
                <div className="benefits-text">
                  <p className="benefits-text-title">
                    {benefit.text}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="col-md-6 col-sm-8 col-12">
          <SignupFormWrapper
            orgType={orgType}
            user={user}
            userType={userType}
          />
        </div>

      </div>
    </div>
  );
}

SignupPage.propTypes = {
  orgType: PropTypes.oneOf(Object.values(ORG_TYPES)),
  user: PropTypes.shape({}),
  userType: PropTypes.oneOf(Object.values(USER_TYPES)),
};

SignupPage.defaultProps = {
  orgType: ORG_TYPES.BUSINESS,
  user: {},
  userType: USER_TYPES.ADMINISTRATOR,
};

export default SignupPage;
